import script from "./SampleRequestDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./SampleRequestDetailView.vue?vue&type=script&setup=true&lang=js"

import "./SampleRequestDetailView.vue?vue&type=style&index=0&id=99869020&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99869020"]])

export default __exports__